import { Component, ViewChild, OnInit } from '@angular/core';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { DriveInstructionsDrawerService } from '../../services/drive-instructions-drawer.service';
import { GroupTourPointListComponent } from './tour-points-list/group-tour-point-list.component';
import { TourPointsDetailsListComponent } from './tour-points-details-list/tour-points-details-list.component';

@Component({
    selector: 'cal-transport-order-drive-instructions-dialog',
    standalone: true,
    imports: [
        MatSidenavModule,
        MatDrawer,
        GroupTourPointListComponent,
        TourPointsDetailsListComponent
    ],
    providers: [],
    templateUrl: './transport-order-drive-instructions-dialog.component.html',
    styleUrl: './transport-order-drive-instructions-dialog.component.scss'
})
export class TransportOrderDriveInstructionsDialogComponent implements OnInit {
    @ViewChild('tourPointsDrawer') tourPointsDrawer: MatDrawer | undefined;

    constructor(
        private driveInstructionsDrawerService: DriveInstructionsDrawerService
    ) {}

    ngOnInit() {
        this.driveInstructionsDrawerService.isDrawerOpened.subscribe((value: boolean) => {
            if (this.tourPointsDrawer?.opened !== value) {
                this.tourPointsDrawer?.toggle();
            }
        });
    }

    onDrawerClosed(): void {
        this.driveInstructionsDrawerService.setDrawerOpened(false);
    }

    getDrawerContainerClass(): string {
        let result = 'h-screen top-0 right-0 !fixed';

        if (this.tourPointsDrawer?.opened) {
            result += this.driveInstructionsDrawerService.isDrawerDetailsSectionOpened.getValue()
                ? ' mat-drawer-fully-expanded'
                : ' mat-drawer-expanded';
        }

        return result;
    }

    getDrawerClass(): string {
        let result = 'grid grid-cols-2 items-start gap-3 shrink-0';

        if (this.tourPointsDrawer?.opened) {
            result += this.driveInstructionsDrawerService.isDrawerDetailsSectionOpened.value
                ? ' mat-drawer-fully-expanded'
                : ' mat-drawer-expanded';
        }
        return result;
    }

    getContentClass(): string {
        let result = '';

        if (this.tourPointsDrawer?.opened) {
            result += this.driveInstructionsDrawerService.isDrawerDetailsSectionOpened.value
                ? 'col-span-1'
                : 'col-span-2';
        }

        return result;
    }

    shouldShowDetailsDrawer(): boolean | undefined {
        return this.driveInstructionsDrawerService?.isDrawerOpened.getValue() && this.driveInstructionsDrawerService.isDrawerDetailsSectionOpened.getValue();
    }
}